import { frozen } from "mobx-keystone";
import { notifyIfFirstItemChanged } from "../../helpers/notifications";
import { Cubby } from "../Cubby";

export const updateAddPeerSuccesses = (
  cubby: Cubby,
  newAddPeerSuccesses: any
) => {
  if ((newAddPeerSuccesses.isDefault = false)) {
    notifyIfFirstItemChanged(
      newAddPeerSuccesses,
      cubby.addPeerSuccesses ? cubby.addPeerSuccesses.data : [],
      (item) => item.uri,
      (item) => item.stamp,
      "Success Notification",
      (item) => `Successfully connected to peer: ${item.uri}`,
      "blue"
    );
  }

  // Update the addPeerSuccesses with the new successes
  cubby.addPeerSuccesses = frozen(newAddPeerSuccesses);
};

export const updateOnchainPaymentSuccesses = (
  cubby: Cubby,
  newOnchainPaymentSuccesses: any
) => {
  notifyIfFirstItemChanged(
    newOnchainPaymentSuccesses,
    cubby.onchainPaymentSuccesses ? cubby.onchainPaymentSuccesses.data : [],
    (item) => item.transaction_id,
    (item) => item.stamp,
    "Success Notification",
    (item) =>
      `Successfully sent onchain payment with this transaction: ${item.transaction_id}`,
    "blue"
  );

  // Update the onchainPaymentSuccesses with the new successes
  cubby.onchainPaymentSuccesses = frozen(newOnchainPaymentSuccesses);
};

export const updateCloseChannelSuccesses = (
  cubby: Cubby,
  newCloseChannelSuccesses: any
) => {
  notifyIfFirstItemChanged(
    newCloseChannelSuccesses,
    cubby.closeChannelSuccesses ? cubby.closeChannelSuccesses.data : [],
    (item) => item.transaction_id,
    (item) => item.stamp,
    "Success Notification",
    (item) => `Successfully closed channel.`,
    "blue"
  );

  // Update the closeChannelSuccesses with the new successes
  cubby.closeChannelSuccesses = frozen(newCloseChannelSuccesses);
};

export const updateOpenChannelSuccesses = (
  cubby: Cubby,
  newOpenChannelSuccesses: any
) => {
  notifyIfFirstItemChanged(
    newOpenChannelSuccesses,
    cubby.openChannelSuccesses ? cubby.openChannelSuccesses.data : [],
    (item) => item.transaction_id,
    (item) => item.stamp,
    "Success Notification",
    (item) => `Successfully opened channel.`,
    "blue"
  );

  // Update the openChannelSuccesses with the new successes
  cubby.openChannelSuccesses = frozen(newOpenChannelSuccesses);
};
